// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3Ujdi","noInteraction":"EventWrapper_noInteraction__2yB9r"};